<template lang="pug">
div
  v-data-table.elevation-1.mt-4(
    :headers="headers",
    :items="usercaseList",
    :items-per-page="5",
    :sort-by="['ID']"
  )
    template(v-slot:item.payment_status="{ item, value }")
      span.font-weight-bold.text-uppercase.text-no-wrap(
        :style="{ color: value ? '#50bdc1' : '#b71c1c' }",
        v-text="value ? 'paid' : 'not paid'"
      )
    template(v-slot:item.status="{ value }")
      v-chip {{ fStatus(value) }}
    template(v-slot:item.ID="{ value }")
      span SL-{{ value }}
    template(v-slot:item.case_profile_type="{ value }")
      span {{ fProfileType(value) }} licenсe
    template(v-slot:item.CreatedAt="{ value }")
      span {{ fDate(value) }}
    //template(v-slot:item.UpdatedAt="{ value }")
    //  span {{ fDate(value) }}
    template(v-slot:item.view="{ item, value }")
      v-btn(
        style="color: #ffffff",
        color="#50bdc1",
        @click="viewCase(item.ID)"
      ) view
</template>

<script>
import { format } from "date-fns";
import { statuses } from "@/data/statuses";
import { mapState } from "vuex";

export default {
  name: "employer-case-table",

  data: () => ({
    headers: [
      { text: "Case number", value: "ID" },
      { text: "Category", value: "case_profile_type" },
      { text: "Created", value: "CreatedAt" },
      { text: "Status", value: "status" },
      { text: "Payment status", value: "payment_status" },
      { text: "Actions", value: "view", sortable: false },
    ],
  }),

  computed: {
    ...mapState("usercase", ["usercaseList"]),

    payDialog: {
      get() {
        return this.$store.state.payDialog;
      },
      set(v) {
        this.$store.commit("setPayDialog", v);
      },
    },
  },

  methods: {
    fProfileType(v) {
      if (v === "Sponsorship") return "Sponsor";
      return v;
    },

    fStatus(v) {
      return statuses.find(({ alias }) => alias === v)?.label ?? "???";
    },

    fDate(v) {
      return format(new Date(v), "dd.MM.yyyy HH:mm");
    },

    viewCase(ID) {
      this.$router.push(`/cases/${ID}/sponsorship/overview`);
    },
  },

  watch: {
    payDialog(v) {
      if (!v) {
        this.$emit("refresh");
      }
    },
  },
};
</script>
